import { useEffect } from "react";

import { useBreakpoint } from "use-breakpoint";

import { cn } from "@/lib/utils";
import useChatStore from "@/stores/useChatStore";
import useGlobalStore from "@/stores/useGlobalStore";
import { bubbleLoaderStyle } from "@/components/style";
import { BREAKPOINTS } from "@/constants/defaultValue";
import { useDynamicViewportHeight } from "@/hooks/useViewportPolyfill";

import RemiderItems from "./RemiderItems";
import Nav from "@/modules/chat-app/components/Nav";
import Header from "@/modules/chat-app/components/Header";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

function ReminderList() {
  const { breakpoint } = useBreakpoint(BREAKPOINTS);
  const footerHeight = useChatStore((state) => state.footerHeight);
  const isMobile = ["xs", "sm"].includes(breakpoint);
  const dynamicViewportHeight = useDynamicViewportHeight();

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const showSuggestionPanel = useGlobalStore((state) => state.showSuggestionPanel);
  const hideSuggestionPanel = useGlobalStore((state) => state.hideSuggestionPanel);

  useEffect(() => {
    if (searchParams.get("reminderId")) {
      navigate(`/reminder/${searchParams.get("reminderId")}`, { replace: true });
    }
  }, []);

  useEffect(() => {
    if (isMobile) {
      useGlobalStore.setState({ navVisible: false });
    }
  }, [breakpoint, isMobile]);

  // Sử dụng height tự động cho mobile khi keyboard xuất hiện
  const containerHeight = isMobile ? "100dvh" : `${dynamicViewportHeight}px`;
  const reminderHeight = isMobile
    ? "calc(100dvh - 85px)" // Để browser tự động tính toán với dvh
    : `${dynamicViewportHeight - (footerHeight + 110)}px`;

  return (
    <div className={cn("flex flex-col overflow-hidden bg-[#F6F8FC] pb-[env(safe-area-inset-bottom)]", isMobile ? "mobile-viewport" : "")} style={!isMobile ? { height: containerHeight } : {}}>
      <style>{bubbleLoaderStyle}</style>
      <div className="flex flex-1 overflow-hidden">
        <Nav />

        <div className="w-full flex flex-col">
          <Header />

          <div className="flex flex-row flex-1 overflow-hidden">
            <div className={cn("transition-all duration-300 ease-in-out flex flex-col", !isMobile && showSuggestionPanel ? "w-[calc(100%-280px)]" : "w-full")}>
              <div
                className="mx-auto overflow-auto flex-1 overscroll-contain w-full"
                style={{
                  maxHeight: "100vh",
                  background: "radial-gradient(200% 200% at 50% 50%, rgb(194 225 255 / 34%) 0%, rgba(230, 246, 244, 0) 20%)",
                }}
              >
                <RemiderItems />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReminderList;
